import { render } from "./OtpVerification.vue?vue&type=template&id=3d3521fa&scoped=true"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=3d3521fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3521fa"]])

export default __exports__